import { create } from 'zustand';

interface OnionState {
  enabled: boolean;
  framesBefore: number;
  framesAfter: number;
  opacity: number; // ghost opacity (0-1)
  toggle: () => void;
  setFramesBefore: (n: number) => void;
  setFramesAfter: (n: number) => void;
  setOpacity: (o: number) => void;
}

export const useOnionStore = create<OnionState>((set) => ({
  enabled: false,
  framesBefore: 2,
  framesAfter: 2,
  opacity: 0.3,
  toggle: () => set((s) => ({ enabled: !s.enabled })),
  setFramesBefore: (n) => set({ framesBefore: Math.max(1, Math.min(5, n)) }),
  setFramesAfter: (n) => set({ framesAfter: Math.max(1, Math.min(5, n)) }),
  setOpacity: (o) => set({ opacity: Math.max(0.05, Math.min(0.8, o)) }),
}));
